export default {
	apiKey: "AIzaSyBFnMgP2C1YxQNBs-3Db7TmiBvTNSiebH0",
	authDomain: "mun-manager-e4968.firebaseapp.com",
	projectId: "mun-manager-e4968",
	storageBucket: "mun-manager-e4968.appspot.com",
	messagingSenderId: "1014086910947",
	appId: "1:1014086910947:web:0c9ddc22ddf0d2c95596d6",
	measurementId: "G-0KJBP0NQQF"
  };